import Toolbar from '@material-ui/core/Toolbar'

import {withStyles} from '../../theme'

export const height = 64
export default withStyles(
  theme => ({
    root: {
      height: `${height}px`,
      alignItems: 'stretch',
    },
    gutters: {
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
  }),
  {name: 'LFToolbar'},
)(Toolbar)
